// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-popup-title',
  templateUrl: './popup-title.component.html',
  styleUrls: ['./popup-title.component.scss'],
})
export class PopupTitleComponent {
}
